import React from 'react'
import { Link } from 'react-router-dom';

class About extends React.Component {
    render() {
        return (
            <div className="container">
                <nav id="aboutNavBar" className="navbar navbar-expand-lg navbar-dark bg-black">
                    <Link to="/">
                        <a className="navbar-brand" href="#">ISI Anywhere</a>
                    </Link>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        {/* <ul className="navbar-nav">
                            <li className="nav-item active">
                                 <a className="nav-link" href="#">Home<span className="sr-only">(current)</span></a>
                            </li>
                        </ul> */}
                    </div>
                </nav>
                <div className="accordion accordion-secondary">
                    <div className="card">
                        <div className="card-header" id="headingOne" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" >
                            <div className="span-icon" style={{ "color": "#1C23BA" }} >
                                <div className="flaticon-chat-1"></div>
                            </div>
                            <div className="span-title" style={{ "color": "#1C23BA" }}>
                                About ISI Anywhere?
                            </div>
                            <div className="span-mode"></div>
                        </div>

                        <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#headingOne">
                            <div className="card-body">
                                <h3>Version 1.4.15 </h3>
                                <h3>What is ISI Anywhere?</h3>
                                <p>ISI Anywhere's is a one stop application to view pending notifications/approvals all in one application. </p>
                                <hr></hr>

                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header collapsed" id="headingTwo" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            <div className="span-icon" style={{ "color": "#1C23BA" }}>
                                <div className="flaticon-chat-1"></div>
                            </div>
                            <div className="span-title" style={{ "color": "#1C23BA" }}>
                                FAQ
                            </div>
                            <div className="span-mode"></div>
                        </div>
                        <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#headingTwo">
                            <div className="card-body">
                                <h3>How often does data refresh?</h3>
                                <p>Automatic refresh occurs every 4 hours. You can also manually refresh by clicking the "refresh" button in the options menu.</p>
                                <hr></hr>
                                <h3>Can I approve from the application? </h3>
                                <p>Currently you can approve RCE's from the website.</p>
                                <hr></hr>
                                <h3>How does ISU filtering work?</h3>
                                <p>ISU is different because it counts down to a due date instead of aging like other applications. ISU filtering is as follows:</p>
                                <ul>
                                    <li>Approvals -> Assignments</li>
                                    <li>0-3 days -> 11-30 days left</li>
                                    <li>4-7 days -> 7-10 days left</li>
                                    <li>7+ days -> 6 or less days left</li>
                                </ul>
                                <hr></hr>
                                <h3>Other than seeing counts of data what else can I do?</h3>
                                <p>You can quickly access a specific application's website by clicking on a task. Task will dissapear but will update once refreshed.</p>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header collapsed" id="headingThree" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            <div className="span-icon" style={{ "color": "#1C23BA" }}>
                                <div className="flaticon-chat-1"></div>
                            </div>
                            <div className="span-title" style={{ "color": "#1C23BA" }}>
                                Contact Us
                            </div>
                            <div className="span-mode"></div>
                        </div>
                        <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#headingThree">
                            <div className="card-body">
                                <h3>Create an IT HelpNow ticket with Intuitive Anywhere Web as the subject</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default About;